<template>
  <div class="cell">
    <label class="lb">{{ label }}</label>

    <label class="ext" v-if="$slots.ext">
      <slot name="ext"></slot>
      <i class="iconfont icon-gou"></i>
    </label>

    <div class="field">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {},
  data() {
    return {}
  },
  methods: {},
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';
$wl: 192px - 24px;
// $wr: 25px + 36px + 10px;
$wr: 0px;

.cell {
  position: relative;
  min-height: rem(100px);
  @include border(bottom, #ddd);

  .lb {
    float: left;
    width: rem($wl);
    margin-right: rem($wl * -1);
    color: #666;
    font-size: rem(30px);
    line-height: rem(100px);
  }
  .ext {
    float: right;
    width: rem($wr);
    height: 100%;
    margin-left: rem($wr * -1);
    input {
      display: none;
    }
    i {
      margin-top: rem(32px);
      display: inline-block;
      width: rem(36px);
      height: rem(36px);
      border: 1px solid #ddd;
      border-radius: 2px;
      text-align: center;
      font-size: rem(18px);
      line-height: rem(36px);
      color: transparent;
    }
    input[type='checkbox']:checked + i {
      background-image: linear-gradient(to right, #ff7d46, #ff4b4b);
      border: none;
      color: #fff;
    }
  }
  .field {
    margin-left: rem($wl);
    margin-right: rem($wr);
    input {
      border: none;
      background: none;
      width: 100%;
      font-size: rem(30px);
      line-height: rem(40px);
      height: rem(40px);
      padding: rem(30px) 0;
      box-sizing: content-box;
    }
    ::-webkit-input-placeholder {
      font-size: rem(30px);
      color: #ccc;
    }
    textarea,
    .textarea {
      border: none;
      background: none;
      width: 100%;
      font-size: rem(30px);
      line-height: rem(40px);
      padding: rem(30px) 0;
      box-sizing: content-box;
      resize: none;
    }
  }
}
</style>
